import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useEffect, useRef } from "react";
import { PalletSection } from "../../interfaces/intakes.reports";
import { pallgrowDefects } from "../../helpers/defectsTable";
import { GradeNum, GradeResult } from "../../interfaces/interfaces";

ChartJS.register(ArcElement, Tooltip);

interface Props {
    palletId: string;
    pallgrow: PalletSection;
    chartIndex: number;
    grade: GradeNum;
    onReady: (id: string, index: number, img: string) => void;
}

ChartJS.register(ArcElement, Tooltip, Legend);
export const PDFDonutCat = ({ palletId, pallgrow, chartIndex, grade, onReady }: Props) => {
    const ref = useRef<any>();

    const { totalRest, totalMajor, totalMinor } = pallgrowDefects(pallgrow.data, (pallgrow.major || []), (pallgrow.minor || []))

    const nameRest = GradeResult[`grade${grade}`]
    const chartdata = {
        labels: [nameRest, "Major defects", "Minor defects"],
        datasets: [
            {
                label: "Markets Monitored",
                data: [ totalRest,  totalMajor,  totalMinor],
                backgroundColor: ["#39b54a", "#FF4D4D", "#f9b233"],
                borderColor: ["#39b54a", "#FF4D4D", "#f9b233"],
                borderWidth: 1,
            },
        ],
    };

    useEffect(() => {
        // if (pallgrow.data?.length === 0) return;

        const timer = setTimeout(() => {
            if (!ref.current) return;

            const img = ref.current.toBase64Image();
            onReady(palletId, chartIndex, img);

        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="tw-fixed tw-opacity-0 tw-pointer-events-none tw-w-[300px]">
            <Doughnut
            ref={ref}
                options={{
                    plugins: {
                        legend: { position:'bottom' },
                    },

                }}
                data={chartdata}
            />
        </div>
    );
};
